import React, { PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import { fieldClass } from 'common/semantic/utils';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = true;
  }

  return errors;
};

class FunnelForm extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  render() {
    const { fields: { name } } = this.props;

    return (
      <form className="ui form">
        <div className={fieldClass(name)}>
          <label>Nom</label>
          <input type="text" name="name" placeholder="Nom" {...name} />
        </div>
      </form>
    );
  }
}

export default reduxForm(
  {
    form: 'funnel',
    fields: ['name'],
    validate,
  },
  state => {
    const { funnel } = state.funnels.funnel;

    return {
      initialValues: {
        name: funnel.name,
      },
    };
  }
)(FunnelForm);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/FunnelForm.js